import React from "react";
import ContentLoader from "react-content-loader";

const PageLoader = ({ blockHeights = [50, 200, 150], width = "100%", blockPadding = 20 }) => {
  // 1) Use a numeric fallback for the internal viewBox
  const numericViewBoxWidth = 1200;
  const numericViewBoxHeight = blockHeights.reduce((acc, h) => acc + h + blockPadding, 0);

  // 2) Track our running vertical offset for each rectangle
  let yOffset = 0;

  return (
    <ContentLoader
      speed={2}
      // The rendered <svg> can be 100% wide to fill its container
      width={width}
      // The rendered <svg> height is at least the total blocks + padding
      height={numericViewBoxHeight}
      // But the viewBox must be numeric:
      viewBox={`0 0 ${numericViewBoxWidth} ${numericViewBoxHeight}`}
      backgroundColor="#00000017"
      foregroundColor="#00000030"
    >
      {blockHeights.map((height, index) => {
        // For each block, place a rectangle of fixed width=100 or any numeric dimension you want
        const rect = (
          <rect
            key={index}
            x="0"
            y={yOffset}
            rx="5"
            ry="5"
            width="100%"
            height={height}
          />
        );
        // Increase the offset for the next block
        yOffset += height + blockPadding;
        return rect;
      })}
    </ContentLoader>
  );
};

export default PageLoader;